import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {UrlDto} from "../item/url.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {VoidDto} from "../dto/void.dto";
import {AuthLogoutDto} from "../dto/auth-logout.dto";

@Injectable({providedIn: 'root'})
export class AuthRepo {

  private readonly authLogin: string = '/v1/auth/login';
  private readonly authSession: string = '/v1/auth/session';
  private readonly authLogout: string = '/v1/auth/logout';

  private readonly http: HttpClient = inject(HttpClient);

  public buildLoginUrl(redirect: string): string {
    return UrlBuilder.builder().addPath(this.authLogin).addQueryParams('redirect', redirect).build().getUrl();
  }

  public readSession(): Observable<WrapperDto<VoidDto>> {
    const url: UrlDto = UrlBuilder.builder().addPath(this.authSession).build();
    return this.http.get<WrapperDto<VoidDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public logout(): Observable<WrapperDto<AuthLogoutDto>> {
    const url: UrlDto = UrlBuilder.builder().addPath(this.authLogout).build();
    return this.http.post<WrapperDto<AuthLogoutDto>>(url.getUrl(), null, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
